// Checks whether the entire input sequence can be matched
// against the regular expression.
export function matchesEntirely() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var regular_expression = arguments[1];

	return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=util.js.map